import { render, staticRenderFns } from "./longStoragePTM.vue?vue&type=template&id=11dd73bf&scoped=true&"
import script from "./longStoragePTM.vue?vue&type=script&lang=js&"
export * from "./longStoragePTM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dd73bf",
  null
  
)

export default component.exports